import { createContext } from 'react';
import { ModalContextValue } from './types';

export const ModalContext = createContext<ModalContextValue>({
  showModal: () => {
    throw new Error('showModal was used outside of ModalProvider!');
  },
});
